export enum ETransactionType {
  purchase = 'purchase',
  deposit = 'deposit',
  withdraw = 'withdraw',
  cancel = 'cancel',
  tradeOut = 'tradeOut',
  tradeIn = 'tradeIn',
}
